import { render, staticRenderFns } from "./ToxicHabitPrint.vue?vue&type=template&id=63532176&"
import script from "./ToxicHabitPrint.vue?vue&type=script&lang=js&"
export * from "./ToxicHabitPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports